import React from 'react';

import { Chip } from '@mui/material';

export type VerificationStatus = 'Approved' | 'Pending' | 'Rejected';

interface Props {
  status: VerificationStatus;
}

const getStatusColor = (status: VerificationStatus): 'success' | 'warning' | 'error' => {
  switch (status) {
    case 'Approved':
      return 'success';
    case 'Pending':
      return 'warning';
    case 'Rejected':
      return 'error';
  }
};

const getStatusLabel = (status: VerificationStatus): string => {
  switch (status) {
    case 'Approved':
      return 'Verified';
    case 'Pending':
      return 'Unverified';
    default:
      return status;
  }
};

export default function VerificationStatusChip({ status }: Props) {
  return <Chip label={getStatusLabel(status)} color={getStatusColor(status)} size="small" />;
}
